import { useState, useEffect, useMemo } from "react";
import { Routes, Route, BrowserRouter } from "react-router";
import Home from "./map.jsx";
import Quiz from "./quiz.jsx";
import Admin from "./admin.jsx";
import "./App.css";
 
export default function App() {
 
  return (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/quiz" element={<Quiz />} />
            
            <Route path="*" element={<Home />} />
        </Routes>
    </BrowserRouter>
  );
}